import * as d3 from 'd3';

export const COLOR_BY_OPTIONS = [
  { label: 'PL Owner', field: 'pl_owner_name' },
  { label: 'Practice Tier', field: 'practice_tier' },
  { label: 'Sub-network', field: 'sub_network' },
  { label: 'Engagement Score', field: 'engagement_score' },
  { label: 'Implementation Status', field: 'implementation_status' },
];

export const SIZE_BY_OPTIONS = [
  { label: 'None', field: null },
  { label: 'Engagement Score', field: 'engagement_score' },
  { label: 'Attribution', field: 'attribution' },
];

export const TILE_STYLES = [
  {
    label: 'Light',
    url: 'https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}@2x.png',
  },
  {
    label: 'Dark',
    url: 'https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png',
  },
  {
    label: 'No Labels',
    url: 'https://a.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}@2x.png',
  },
  {
    label: 'Street',
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  },
  {
    label: 'Terrain',
    url: 'https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png',
  },
];

export const PALETTE = [
  '#F76734', '#7799C2', '#B8E0B2', '#6C5CE7', '#FDCB6E',
  '#E17055', '#00CEC9', '#D63031', '#74B9FF', '#A29BFE',
  '#55EFC4', '#FAB1A0', '#81ECEC', '#636E72', '#FD79A8',
];

// Friendly labels for null / unset values, per dimension. Null stays null in the
// underlying data (and in API responses) — this is display-only for the map so
// users can see and filter TO the unset practices for cleanup.
export const NULL_LABELS = {
  sub_network: 'Independent',
  practice_tier: 'No tier set',
  pl_owner_name: 'Unassigned',
  implementation_status: 'No status set',
  participation_status: 'No status set',
  market: 'No market set',
  contracts: 'No contract',
};

export const DEFAULT_NULL_LABEL = '(none)';

// Map a raw field value to its display label, substituting the friendly label
// for null / empty values.
export function labelFor(field, value) {
  if (value == null || value === '') return NULL_LABELS[field] || DEFAULT_NULL_LABEL;
  return String(value);
}

export function buildColorScale(markers, field) {
  const labels = [
    ...new Set(markers.map((m) => labelFor(field, m[field]))),
  ].sort((a, b) => a.localeCompare(b));
  return d3.scaleOrdinal().domain(labels).range(PALETTE);
}
